<list-drop-down [disabled]="disabled"
                [button_title]="selected_item?.label"
                [item_label_prop]="'label'"
                [item_hidden_prop]="'hidden'"
                [sort_items]="false"
                [items]="dropdown_items"
                (item_selected)="selectDateRange($event.item)">
</list-drop-down>
